// @flow
/* eslint-disable no-use-before-define */

export type PriceType = $Values<typeof PRICE_TYPE>
export type PriceTypeName = $Keys<typeof PRICE_TYPE>

export const PRICE_TYPE = {
  NO_PRICE: 'no_price',
  FIXED_PRICE: 'fixed_price',
  BASE_PRICE: 'base_price',
  PRICE_RANGE: 'price_range',
  ESTIMATE_PRICE: 'estimate_price',
}

export default PRICE_TYPE
